import BridgeV2 from "@akulaku/web-bridge";
import get from "lodash/get";
import performanceCollection from "@al/performance-collect";
import { customSentryReportIfEnabled } from "@al/next/al-ex";
import { IO, I18nTools } from "@al/base-lib";
import JsCookie from "js-cookie";

import "./style/antd-mobile-theme.global.less";
import "./style/index.global.scss";

import GetDeviceIdEventBus from "~/common/utils/getDevieIdEventBus";
import { tracker } from "~/common/tracker";
import { setIO } from "~/common/io";

import { getCookieOpts } from "../common/utils";
import getAppName from "../common/utils/getAppName";
import { COOKIE_KEYS_MAP } from "../common/constant";
import { getDefaultCountryCode, getDefaultLanguageCode } from "../common/utils/base";

import { actions, reducer } from "./redux";
import { extendsPageConfig } from "./extendsPageConfig";

// 性能监控

const performanceCollectionConfig =
  process.env.BUILD_ENV === "prod"
    ? {
        apiKey: "AIzaSyBt7SLd-WLlPpHQcIBlzOhhIbwIjH5Du6g",
        authDomain: "akulaku-web-1a00b.firebaseapp.com",
        databaseURL: "https://akulaku-web-1a00b.firebaseio.com",
        projectId: "akulaku-web-1a00b",
        storageBucket: "akulaku-web-1a00b.appspot.com",
        messagingSenderId: "778102340676",
        appId: "1:778102340676:web:ce7cb60844b75e6181d011",
      }
    : {
        apiKey: "AIzaSyBkk1nKE_vvCL3ceaUVkLP53HROVK8sSkE",
        authDomain: "akulaku-web-test.firebaseapp.com",
        databaseURL: "https://akulaku-web-test.firebaseio.com",
        projectId: "akulaku-web-test",
        storageBucket: "akulaku-web-test.appspot.com",
        messagingSenderId: "998612602448",
        appId: "1:998612602448:web:2f535e30c406f2d1dc0b55",
        measurementId: "G-FN5QM7B0K8",
      };

if (process.browser) {
  const appName = getAppName();

  const prometheusEnabled = appName !== "wisecart";
  const routeNamePrefix = "gp_";
  performanceCollection.init({
    config: performanceCollectionConfig,
    env: process.env.BUILD_ENV,
    pageMode: "ssr",
    routeBase: "/growth-publish",
    // 有一个/mgm/strategy页面没有配置路由，但路由调整可以进入，刷新页面404，next.config.js没有进行配置
    routeConfig: {
      "/main": {
        name: `${routeNamePrefix}main`,
        firebase: {
          enabled: true,
        },
        prometheus: {
          enabled: prometheusEnabled,
          extraInfo: {
            businessType: "增长活动发布",
            businessChildType: "增长活动发布",
          },
        },
      },
    },
    shouldLog: process.env.BUILD_ENV !== "prod",
    shouldReport: process.env.BUILD_ENV !== "local",
  });
}

let saIsLogin = false;

export default function global() {
  return {
    // 全局 actions 和 reducer
    redux: {
      actions,
      reducer,
    },
    // 全局语言推导和语言包
    i18n: {
      resolve: (ctx, lifecycleStatus, initialI18nConf) => {
        const req = ctx.req || {};
        // 初始化一些信息
        I18nTools.initI18nNeedInfo({
          COOKIE_KEYS_MAP: {
            CountryCode: COOKIE_KEYS_MAP.CountryCode,
            CountryId: COOKIE_KEYS_MAP.CountryId,
            LanguageCode: COOKIE_KEYS_MAP.LanguageCode,
            LanguageId: COOKIE_KEYS_MAP.LanguageId,
          },
          buildEnv: process.env.BUILD_ENV,
          cookieOptions: getCookieOpts(req),
          defaultCountryCode: getDefaultCountryCode(ctx),
          // 当query及cookie中不存在时才会使用 defaultLanguageCode
          defaultLanguageCode: getDefaultLanguageCode(ctx),
        });
        return I18nTools.resolveI18n(ctx, lifecycleStatus, initialI18nConf);
      },
      //引入全局语言包
      resource: {
        en: require("./i18n/en.json5"),
        in: require("./i18n/in.json5"),
        ms: require("./i18n/en.json5"),
        vi: require("./i18n/vi.json5"),
        de: require("./i18n/de.json5"),
        es: require("./i18n/es.json5"),
      },
    },
    env: resolveRuntimeEnv,
    prefetchApi: {
      globalUserInfo: {
        critical: true,
        // url: "/capi/personal/user/login-status/get",
        url: "/capi/personal/user/user-info-detail/get",
        method: "post",
        type: "JSON",
        headers: {
          "language-id": "$cookie.languageId",
          "country-id": "$cookie.countryId",
        },
      },
    },
    convertRawResponseToSiteResponse(propKey, xhrResponse, ctx) {
      return IO.convertAxiosResponseToSizeResponse(
        { success: xhrResponse.success, resOrError: xhrResponse.response },
        ctx
      );
    },
    lifecycle(ctx, result, { isExport }) {
      // server / browser 尽可能早的初始化 io
      if (!isExport && ctx) {
        if (!ctx.scope.io) {
          IO.hooks.onUnauthorized = () => {
            if (ctx.store) {
              //登陆态缺失或失效
              // Report.setUid(null);
              // 未登录时，跳转到登录页
              if (process.browser && window.__NEXT_DATA__.requireLogin && ctx.actions.runtime) {
                ctx.store.dispatch(ctx.actions.runtime.setLoginConfirm(true));
              }
            }
          };
          ctx.scope.io = new IO({
            ctx,
            config: { withCredentials: true, headers: { "Content-Type": "application/json" } },
            // 事件
            events: {
              // 添加错误事件回调，一般c端才需要进行捕获错误
              onResponseError(error) {
                if (!error.response || (error.response && error.response.status !== 401)) {
                  const { method, params, url } = error.config;
                  customSentryReportIfEnabled(new Error("response_error"), "io", (scope) => {
                    scope.setExtras({
                      url,
                      lifecycleStatus: ctx.lifecycleStatus ? JSON.stringify(ctx.lifecycleStatus) : "not set",
                      method,
                      params,
                      status: error.response ? error.response.status : undefined,
                      downgrade: typeof window === "undefined" ? "ssr" : window.AL_SSR_DOWNGRADE,
                      time: error.config._ts,
                    });
                  });
                }
              },
            },
          });
        }
        if (!ctx.io) {
          ctx.io = ctx.scope.io;
          setIO(ctx.scope.io);
        }
      }
      // if (ctx && !ctx.io) {
      //   ctx.io = new IO(ctx);
      // }
      if (!saIsLogin && process.browser && ctx && ctx.store) {
        if (ctx.store.getState().sign.isSign) {
          saIsLogin = true;
          tracker.updateSdkConfig({
            sa: {
              userId: ctx.store.getState().sign.userDetail.uid,
            },
          });
          tracker?.login(ctx.store.getState().sign.userDetail.uid);
        }
      }
      if (ctx && !ctx.deviceId) {
        if (process.browser) {
          // 客户端
          if (BridgeV2.isAkulaku()) {
            // app内
            BridgeV2.getDeviceIdV2("", function (res) {
              ctx.deviceId = get(res, "data.deviceId") || "";
              tracker.updateSdkConfig({
                behavior: {
                  v4: {
                    deviceId: get(res, "data.deviceId") || "",
                  },
                },
              });
            });
          } else {
            // app外
            const deviceId = JsCookie.get("deviceid2");
            tracker.updateSdkConfig({
              behavior: {
                v4: {
                  deviceId: deviceId,
                },
              },
            });
            !GetDeviceIdEventBus.isOnGetDeviceId &&
              GetDeviceIdEventBus.listener((value) => {
                ctx.deviceId = value;
                if (!deviceId && value) {
                  tracker.updateSdkConfig({
                    behavior: {
                      v4: {
                        deviceId: value,
                      },
                    },
                  });
                }
              });
          }
        }
      }
      if (ctx && !ctx.getDeviceId) {
        ctx.getDeviceId = new Promise((resolve) => {
          if (process.browser) {
            // 客户端
            if (BridgeV2.isAkulaku()) {
              // app内
              BridgeV2.getDeviceIdV2("", function (res) {
                resolve(get(res, "data.deviceId") || "");
              });
            } else {
              // app外
              GetDeviceIdEventBus.listener(resolve);
            }
          }
        });
      }
    },
    // 扩展 pageConfig 机制，使得业务站点可自己扩展行为
    extendsPageConfig,
  };
}

function resolveRuntimeEnv(ctx, serverEnv) {
  let runtimeEnv;

  // export，无业务环境概念
  if (ctx.lifecycleStatus.isExport) {
    // no stuff
  }

  // server，对仅支持 pre render 的工程来说，仅用于本地 dev
  else if (process.server) {
    runtimeEnv = resolveRuntimeEnvByHostname(ctx.req.hostname);
  }

  // browser，若 server 已指定，以 server 为准；若未指定，从 url 自行推导
  else {
    if (serverEnv && serverEnv.RUNTIME_ENV) {
      runtimeEnv = serverEnv.RUNTIME_ENV;
    } else {
      runtimeEnv = resolveRuntimeEnvByHostname(location.hostname);
    }
  }

  return { RUNTIME_ENV: runtimeEnv };

  function resolveRuntimeEnvByHostname(hostname) {
    if (process.env.RUNTIME_ENV) {
      return process.env.RUNTIME_ENV;
    }
    if (/^sit/.test(hostname)) {
      return "sit";
    } else if (!/^test/.test(hostname) && !(/^localhost/.test(hostname) || /^\d+\.\d+\.\d+\.\d+/.test(hostname))) {
      return "prod";
    } else {
      return "test";
    }
  }
}
